import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserClient } from '../../api/benefits-clients';
import { UserContext } from './user-context.types';
import { CustomWindowExport } from '@benefitsui/app/shared/interfaces/customWindow';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';

@Injectable({ providedIn: 'root' })
export class UserContextResolver {
  constructor(private userClient: UserClient) {}

  resolve(): Observable<UserContext> {
    const result = this.userClient.info().pipe(
      map((rsp) => {
        CustomWindowExport.dataLayer.push({
          userId: rsp.data?.userId ?? Defaults.stringEmpty,
          symClass: rsp.data?.symClass ?? Defaults.stringEmpty
        });
        CustomWindowExport.dataLayer.push({
          event: 'benefitsLoggedIn'
        });
        return {
          currentUserFirstName: rsp.data?.firstName ?? Defaults.stringEmpty,
          currentUserLastName: rsp.data?.lastName ?? Defaults.stringEmpty,
          currentUserFullName: rsp.data?.fullName ?? Defaults.stringEmpty,
          currentUserUserName: rsp.data?.userName ?? Defaults.stringEmpty,
          currentUserEmail: rsp.data?.email ?? Defaults.stringEmpty,
          currentUserPhone: rsp.data?.phoneNumber ?? Defaults.stringEmpty,
          symClass: rsp.data?.symClass ?? Defaults.stringEmpty,
          policyholderInfo: rsp.data?.policyholderInfo,
          symEmployeeInfo: rsp.data?.symEmployeeInfo,
          termConditionConsentInfo: rsp.data?.termConditionConsent
        };
      })
    );

    return result;
  }
}
